import './PinIcon.scss'

import { mdiMessageOutline, mdiPinOffOutline, mdiPinOutline } from '@mdi/js'
import { Icon } from '@mdi/react'
import React from 'react'

import { Box } from '@/components/ui/box'
import { Tooltip } from '@/components/ui/tooltip'

import AgentHeadset from '../agentHeadset'

interface IPinIconProps {
    isPinned: boolean
    onPin: (chatId: string) => void
    chatId: string
    isAgentConversation: boolean
}

const PinIcon: React.FC<IPinIconProps> = ({ isPinned, onPin, chatId, isAgentConversation }) => {
    return (
        <Box
            className={`pin-icon-box ${isPinned ? 'pinned' : ''}`}
            width="20px"
            mr="10px"
            onClickCapture={(e) => {
                e.stopPropagation()
                e.preventDefault()
                onPin(chatId)
            }}
        >
            {isAgentConversation ? (
                <AgentHeadset chatId={chatId} />
            ) : (
                <Icon path={mdiMessageOutline} size="20px" color="var(--chakra-colors-gray-600)" className="message-icon" />
            )}
            <Tooltip content="Pin" variant="gsk" positioning={{ placement: 'top' }}>
                <span>
                    <Icon path={mdiPinOutline} size="20px" color="var(--chakra-colors-gray-600)" className="pin-icon" />
                </span>
            </Tooltip>
            <Tooltip content="Unpin" variant="gsk" positioning={{ placement: 'top' }}>
                <span>
                    <Icon path={mdiPinOffOutline} size="20px" color="var(--chakra-colors-gray-600)" className="pin-icon-off" />
                </span>
            </Tooltip>
        </Box>
    )
}

export default PinIcon
